













































































































































































































































































































































































































































































































































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import OverlayWindow from "../general/OverlayWindow.vue";
import PointerMenu from "../general/PointerMenu.vue";
import Loading from "../general/Loading.vue";
import CategoryTypeSelect from "../general/CategoryTypeSelect.vue";

import SettingsJson from "../../shared/SettingsJson";
import ModulesJson from "../../shared/ModulesJson";
import PriceTemplateJson, {
  defaultPriceTemplateJson,
  validatePriceTemplateJson,
  validatePriceTemplateJsonAddNew,
} from "../../shared/PriceTemplateJson";
import CategoryTypeJson from "../../shared/CategoryTypeJson";
import { CategoryTypeType } from "../../shared/CategoryTypeType";

import { UserPermissionRank, UserPermissionRankNames } from "../../shared/UserPermissionRank";
import UserPermission, { defaultUserPermissionJson } from "../../shared/UserPermission";
import { UserPermissionType, UserPermissionTypeNames } from "../../shared/UserPermissionType";
import UserPermissionTypeInfoJson, { UserPermissionTypeInfos } from "../../shared/UserPermissionTypeInfoJson";

import { validateUserJson } from "../../shared/UserJson";
import { ValidationResult, Validation } from "../../shared/Validation";

type keysForCachedPrices = {
  [key in keyof Pick<
    PriceTemplateJson,
    | "priceDeposit"
    | "priceDepositAdditionalParticipant"
    | "priceNonDeposit"
    | "priceNonDepositAdditionalParticipant"
    | "priceCancellationFee"
  >]: string;
};

export default Vue.extend({
  name: "SettingsPriceTemplateForm",
  components: {
    OverlayWindow,
    PointerMenu,
    Loading,
    CategoryTypeSelect,
  },
  props: {
    restClient: RestClient,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    allActiveModules: Array as PropType<ModulesJson[]>,
    mode: String,
    editable: Boolean,
    priceTemplateId: Number,
    hideInputs: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      CategoryTypeType: CategoryTypeType,
      detailsTitle: "",
      detailsMode: "",
      selectedId: null as number | null,
      details: null as PriceTemplateJson | null,
      cachedPrices: null as keysForCachedPrices | null,
      hasChanges: false,
      toValidate: {} as any,
      validation: null as ValidationResult<PriceTemplateJson> | null,
      submitValidation: false as boolean,
      frontendValidations: {},
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.setCachedData();
  },
  methods: {
    init() {
      this.details = null;
      this.selectedId = this.priceTemplateId;
      this.loadDetails();
    },

    setCachedData() {
      this.setCachedPrices();
    },

    async loadDetails() {
      if (this.selectedId != null) {
        if (this.restClient != null) {
          try {
            this.details = await this.restClient.getPriceTemplate(this.selectedId);

            this.setCachedData();
          } catch (e) {
            alert(e.message);
          }
        }
      } else {
        this.details = this.getDefaultPriceTemplateData();
      }

      this.$nextTick(() => {
        this.hasChanges = false;
      });
    },

    //START set cached data

    setCachedPrices() {
      if (this.details != null) {
        let prices = {
          priceCancellationFee: "0,00",
          priceDeposit: "0,00",
          priceDepositAdditionalParticipant: "0,00",
          priceNonDeposit: "0,00",
          priceNonDepositAdditionalParticipant: "0,00",
        } as keysForCachedPrices;

        let k = prices;
        let i: keyof typeof k;

        for (i in prices) {
          prices[i] = this.getFormatPrice(this.details[i]);
        }

        this.cachedPrices = prices;
      }
    },

    //END set cached data

    getDefaultPriceTemplateData() {
      return { ...defaultPriceTemplateJson() };
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("close");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("close");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.details != null) {
        this.validation = validatePriceTemplateJson(this.details);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    //START set input data (where data be cached)

    formatAndSetCachedPrice(key: keyof keysForCachedPrices) {
      if (this.details != null && this.cachedPrices != null) {
        let price = this.cachedPrices[key].replace(".", ",");

        if (!price.includes(",")) {
          price += ",00";
        }

        if (!price.match(/^\d{1,}(,\d{2})?$/)) {
          price = "";
        }

        this.cachedPrices[key] = price;
        this.details[key] = parseInt(price.replace(/[\D]/g, ""));
      }
    },

    //END set input data (where data be cached)

    async addNewPriceTemplate() {
      if (this.details != null) {
        this.loadingGeneral = true;

        this.submitValidation = true;

        this.validation = validatePriceTemplateJsonAddNew(this.details);

        if (this.validation != null && this.validation.isValid == true) {
          if (this.restClient != null) {
            try {
              this.details = await this.restClient.addPriceTemplate(this.details);
              this.hasChanges = false;
              this.loadingGeneral = false;
              this.closeDetails();
              alert("Der Vorlage wurde erfolgreich hinzugefügt.");
            } catch (e) {
              this.loadingGeneral = false;
              alert(e.message);
            }
          }
        } else {
          this.loadingGeneral = false;
          alert("Die Vorlage konnte nicht hinzugefügt werden. Bitte überprüfen Sie Ihre Angaben.");
        }
      }
    },

    async savePriceTemplate() {
      if (this.details != null) {
        if (this.hasChanges) {
          this.loadingGeneral = true;

          this.validation = validatePriceTemplateJson(this.details);

          if (this.validation != null && this.validation.isValid == true) {
            if (this.restClient != null) {
              try {
                this.details = await this.restClient.updatePriceTemplate(this.details);
                this.hasChanges = false;
                this.loadingGeneral = false;
                alert("Die Änderungen wurden erfolgreich gespeichert.");
                this.closeDetails();
              } catch (e) {
                this.loadingGeneral = false;
                alert(e.message);
              }
            }
          } else {
            this.loadingGeneral = false;
            alert("Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen.");
          }
        } else {
          alert("Es wurden keine Änderungen vorgenommen.");
          this.closeDetails();
        }
      }
    },

    async deletePriceTemplate() {
      if (this.selectedId != null) {
        let c = confirm("Wollen Sie diese Vorlage wirklich unwiderruflich löschen?");
        if (c == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.deletePriceTemplate(this.selectedId);
              this.closeDetails();
              alert("Die Vorlage wurde gelöscht.");
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          //do nothing
        }
      }
    },

    checkHideInput(inputs: string[]) {
      return !inputs.some((i) => !this.hideInputs.includes(i));
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },
  watch: {
    details: {
      handler() {
        this.hasChanges = true;
      },
      deep: true,
    },

    priceTemplateId: {
      handler() {
        this.init();
      },
    },

    loadingGeneral: {
      handler() {
        this.$emit("loading", this.loadingGeneral);
      },
    },
  },
  computed: {
    priceRestrictToTypes: {
      get(): CategoryTypeJson[] | undefined {
        if (this.details != null && "priceRestrictToTypes" in this.details) {
          if (this.details.priceRestrictToTypes == null) {
            return [];
          } else {
            return this.details.priceRestrictToTypes;
          }
        }
      },
      set(value: CategoryTypeJson[]) {
        if (this.details != null && "priceRestrictToTypes" in this.details) {
          if (value.length <= 0) {
            this.details.priceRestrictToTypes = null;
          } else {
            this.details.priceRestrictToTypes = value;
          }
        }
      },
    },

    parsePriceDepositParticipantCount: {
      get(): number | null | undefined {
        if (this.details != null) {
          return this.details.priceDepositParticipantCount;
        }
      },
      set(value: string) {
        if (this.details != null) {
          if (value == "") {
            this.details.priceDepositParticipantCount = null;
          } else {
            this.details.priceDepositParticipantCount = parseInt(value);
          }
        }
      },
    },

    parsePriceNonDepositParticipantCount: {
      get(): number | null | undefined {
        if (this.details != null) {
          return this.details.priceNonDepositParticipantCount;
        }
      },
      set(value: string) {
        if (this.details != null) {
          if (value == "") {
            this.details.priceNonDepositParticipantCount = null;
          } else {
            this.details.priceNonDepositParticipantCount = parseInt(value);
          }
        }
      },
    },

    parsePriceParticipantClassMinimum: {
      get(): number | null | undefined {
        if (this.details != null) {
          return this.details.priceParticipantClassMinimum;
        }
      },
      set(value: string) {
        if (this.details != null) {
          if (value == "") {
            this.details.priceParticipantClassMinimum = null;
          } else {
            this.details.priceParticipantClassMinimum = parseInt(value);
          }
        }
      },
    },

    parsePriceParticipantClassMaximum: {
      get(): number | null | undefined {
        if (this.details != null) {
          return this.details.priceParticipantClassMaximum;
        }
      },
      set(value: string) {
        if (this.details != null) {
          if (value == "") {
            this.details.priceParticipantClassMaximum = null;
          } else {
            this.details.priceParticipantClassMaximum = parseInt(value);
          }
        }
      },
    },
  },
});
